export default __webpack_public_path__ + "static/media/img-matrix-section.dc5dc4cd.webp";